define("CCAW.GoToCheckoutCartDetailedButton.View", [
  "SCView",
  "ccaw_go_to_checkout_cart_detailed_button.tpl",
  "SDB.SelectYourVehicle.View",
  "SDB.Modal.Content.View",
  "ExternalVendor.Inventory.SS2Model",
], function (
  SCViewModule,
  ccaw_go_to_checkout_cart_detailed_button_tpl,
  SDBSelectYourVehicleView,
  SDBModalContentView,
  ExternalVendorInventorySS2Model
) {
  "use strict";

  var SCView = SCViewModule.SCView;

  var CCAWGoToCheckoutCartDetailedButton =
    function CCAWGoToCheckoutCartDetailedButton(options) {
      SCView.call(this);
      this.template = ccaw_go_to_checkout_cart_detailed_button_tpl;

      var Layout = options.container.getComponent("Layout");
      var Environment = options.container.getComponent("Environment");

      var self = this;
      self.layout = Layout;
      self.env = Environment;
      self.container = options.container;

      this.events = {
        "click a.cart-detailed-proceed-to-checkout": "handleProceedToCheckout",
      };

      this.getContext = function getContext() {
        return {};
      };

      function getSelectedVehicle() {
        var vehicle = null;
        var cookies = document.cookie.split(";");
        if (cookies && cookies.length > 1) {
          vehicle = cookies.find(function (cookie) {
            return cookie.indexOf("vehicle=") !== -1;
          });
        }
        return !!vehicle;
      }

      /**
       * Handles the click event for the "Proceed to Checkout" button.
       * If no vehicle is selected, it opens a modal to select a vehicle.
       * If a vehicle is selected, it redirects to the checkout page.
       */
      this.handleProceedToCheckout = function handleProceedToCheckout() {
        var vehicle = getSelectedVehicle();
        if (!vehicle) {
          var modalView = new SDBModalContentView({
            parentView: this.parentView,
            contentView: SDBSelectYourVehicleView,
            container: self.container,
            pageHeader: "What vehicle are you shopping for today?",
            showContinue: true,
            requiresVehicleSelection: true,
          });
          self.layout.showContent(modalView, { showInModal: true });
        } else {
          var currentTouchpoint = self.env.getConfig().currentTouchpoint;
          var touchpoints = this.env.getSiteSetting("touchpoints");
          if (touchpoints && touchpoints.checkout) {
            Backbone.history.location.assign(touchpoints.checkout, {
              trigger: true,
            });
          }
        }
        return;
      };
    };

  CCAWGoToCheckoutCartDetailedButton.prototype = Object.create(
    SCView.prototype
  );
  CCAWGoToCheckoutCartDetailedButton.prototype.constructor =
    CCAWGoToCheckoutCartDetailedButton;

  return CCAWGoToCheckoutCartDetailedButton;
});
